import { Moment } from 'moment';

import { Pipe, PipeTransform } from '@angular/core';

import { MomentFormatter } from '../services/moment-formatter';

import { IMoment } from '../lib/moment';

@Pipe({ name: 'moment' })
export class MomentPipe implements PipeTransform {
  constructor(private formatter: MomentFormatter) { }

  public transform(dateTime: IMoment | Moment, format: string, useUserTimezone: boolean = true) {
    return this.formatter.format(dateTime, format, useUserTimezone);
  }
}
